<template>
    <div
        ref="rootEl"
        class="modal-container modal-container-corner no-transition"
        :class="{ hidden: !display }"
        tabindex="-1"
        role="dialog"
        :aria-hidden="!display"
        @click="close"
        @keydown="escapeToClose"
    >
        <div class="modal-dialog modal-md" role="document" @click="stopPropagationEvent">
            <div class="modal-header">
                <div class="modal-title">{{ t("Select your language") }}</div>
                <button type="button" class="modal-close-btn" :title="t('Close')" @click="goBack">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="modal-body no-padding">
                <div class="settings-list">
                    <div
                        v-for="l in languages"
                        :key="l.id"
                        class="settings-list-item"
                        tabindex="0"
                        @keydown="clickOnEnter"
                        @click="changeLocale(l.id)"
                    >
                        <div class="settings-list-item-icon" :class="{ 'check-invisible': l.id !== lang }">
                            <i class="fas fa-check"></i>
                        </div>
                        <div class="settings-list-item-caption">{{ l.name }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from "vue";
import { AVAILABLE_LANGUAGES, getLanguage, setLanguage } from "@/i18n";
import { useDropdownPanel } from "@/composables/useDropdownPanel";

defineOptions({ name: "ChangeLanguageDropdown" });

const display = defineModel<boolean>("display");
const emit = defineEmits<{
    openModal: [name: string];
}>();

const rootEl = useTemplateRef<HTMLElement>("rootEl");
const { close, escapeToClose, stopPropagationEvent, clickOnEnter } = useDropdownPanel(display, rootEl);

const languages = AVAILABLE_LANGUAGES.map((l) => {
    return { id: l.id, name: l.name };
});
const lang = ref(getLanguage());

const changeLocale = (locale: string) => {
    lang.value = locale;
    setLanguage(locale);
    close();
    emit("openModal", "user-settings");
};

const goBack = () => {
    close();
    emit("openModal", "user-settings");
};
</script>

<style></style>
